import { Link } from "react-router-dom";

interface BDServiceCardProps {
  name: string;
  image: string;
  description: string;
  to?: string;
  readMore?: string;
}

export default function BDServiceCard({ name, image, description, to = "/kontakt", readMore }: BDServiceCardProps) {
  const readMoreText = readMore || "Mehr erfahren";

  return (
    <div className="group bg-white rounded-lg overflow-hidden border border-background-200 transition-all duration-300 hover:border-primary-300 self-stretch flex flex-col">
      {/* Image */}
      <div className="h-40 md:h-48 overflow-hidden w-full flex-shrink-0">
        <img
          src={image}
          alt={name}
          title={name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>

      {/* Content */}
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
          {name}
        </h3>
        <p className="text-sm text-foreground-950 leading-relaxed mb-4 min-h-[88px]">
          {description}
        </p>
        <Link
          to={to}
          className="inline-flex items-center gap-1 px-4 py-2 font-heading text-sm font-medium text-primary-600 border border-primary-300 rounded-md hover:bg-primary-500 hover:text-white hover:border-primary-500 transition-colors cursor-pointer whitespace-nowrap mt-auto w-fit"
        >
          {readMoreText}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>
    </div>
  );
}